import Main from '@/components/main/Main';
// 支付模块的路由

export default [{
  name: 'account',
  path: '/account',
  component: Main,
  redirect: '/account/advertiser',
  meta: {
    showInMenu: true,
    showAlways: true, // 表示一定要展示子菜单
    title: '账户',
    icon: 'ios-apps'
  },
  children: [{
    name: 'account_advertiser',
    path: '/account/advertiser',
    component: () =>
                import('@/emc-dmp/views/dmpadvertiser'),
    meta: {
      showInMenu: true,
      path: '/account/advertiser',
      title: '广告投放账号',
      icon: 'logo-apple'
    }
  },
  // {
  //     name: 'test',
  //     path: '/dmpadvertiser/test',
  //     component: () =>
  //         import ('@/emc-dmp/views/dmpadvertiser/test'),
  //     meta: {
  //         showInMenu: true,
  //         path: '/dmpadvertiser/test',
  //         title: '测试页面',
  //         icon: 'logo-apple'
  //     }
  // },
  {
    name: 'account_app',
    path: '/account/app',
    component: () =>
                import('@/emc-dmp/views/dmpapp'),
    meta: {
      showInMenu: true,
      path: '/account/app',
      title: '项目管理',
      icon: 'logo-apple'
    }
  },
  {
    name: 'account_app_add',
    path: '/account/app/add',
    component: () =>
                import('@/emc-dmp/views/dmpapp/EditPage'),
    meta: {
      showInMenu: false
    }
  },
  {
    name: 'account_app_group_add',
    path: '/account/app/group/add',
    component: () =>
                import('@/emc-dmp/views/dmpappgroup/EditPage'),
    meta: {
      showInMenu: false
    }
  },
  {
    name: 'account_user',
    path: '/account/user',
    component: () =>
                import('@/emc-system/views/user'),
    meta: {
      showInMenu: true,
      path: '/account/user',
      title: '用户账号',
      icon: 'logo-apple'
    }
  },
  {
    name: 'account_user_add',
    path: '/account/user/add',
    component: () =>
                import('@/emc-system/views/user/EditPage'),
    meta: {
      showInMenu: false
    }
  }
  ]
}];
